
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/terms-and-condition",
      function () {
        return require("private-next-pages/policy/terms-and-condition.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/terms-and-condition"])
      });
    }
  